import { graphql, StaticQuery } from "gatsby"
import * as React from "react"
import {
  IconMail,
  IconPhone,
  IconCalendarTime,
  TablerIcon,
} from "@tabler/icons"
import { Map } from "./Map"

const icons: { [key: string]: TablerIcon } = {
  mail: IconMail,
  phone: IconPhone,
  calendar: IconCalendarTime,
}

const query = graphql`
  {
    allContact {
      nodes {
        icon
        times {
          time
          day {
            de
            en
            nl
          }
        }
        title {
          de
          en
          nl
        }
        notes {
          de
          en
          nl
        }
        button {
          label {
            nl
            en
            de
          }
          link
        }
        map
      }
    }
  }
`

export interface ContactProps {
  lang: string
}

export class Contact extends React.Component<ContactProps> {
  render() {
    return (
      <div className="flex flex-col gap-4">
        <StaticQuery
          query={query}
          render={data => {
            return data.allContact.nodes.map(
              (
                contact: {
                  icon: string
                  title: { [key: string]: string }
                  button: {
                    label: { [key: string]: string }
                    link: string
                  }
                  notes: { [key: string]: string }[]
                  times: Array<{
                    time: string
                    day: { [key: string]: string }
                  }>
                  map?: boolean
                },
                index: number
              ) => {
                const Icon = icons[contact.icon]
                return (
                  <div
                    className="bg-gray-50 p-6 rounded-2xl flex flex-col gap-6 w-full max-w-xl"
                    key={index}
                  >
                    <div className="flex flex-col sm:flex-row gap-2 justify-between items-center">
                      <div className="flex gap-2 items-center ">
                        {Icon && <Icon size={32} stroke={2} />}
                        <h2 className="text-xl">
                          {contact.title[this.props.lang]}
                        </h2>
                      </div>
                      {contact.button && (
                        <p className="w-auto min-w-fit">
                          <a href={contact.button.link} className="button">
                            {contact.button.label[this.props.lang]}
                          </a>
                        </p>
                      )}
                    </div>
                    {contact.notes && (
                      <>
                        {contact.notes.map((note, index) => (
                          <p key={index}>{note[this.props.lang]}</p>
                        ))}
                      </>
                    )}
                    {contact.times && (
                      <>
                        <div className="flex flex-col sm:flex-row gap-6">
                          {contact.times.map((time, index) => (
                            <div
                              className="flex flex-col items-center"
                              key={index}
                            >
                              <span className="text-sm font-bold">
                                {time.day[this.props.lang]}
                              </span>
                              <span className="text-sm">{time.time}</span>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                    {contact.map === true ? <Map /> : null}
                  </div>
                )
              }
            )
          }}
        />
      </div>
    )
  }
}
